export const teachersData = [
  {
    id: 1,
    name: 'Sheikh Abdul Rahman',
    title: 'Quran Memorization Specialist',
    qualification: 'Hafiz-e-Quran, Ijazah in 7 Qira\'at',
    experience: '15 years',
    specialization: ['Hifz', 'Tajweed', 'Qira\'at'],
    language: ['Arabic', 'English', 'Urdu'],
    description: 'Sheikh Abdul Rahman is a dedicated Quran teacher with over 15 years of experience in teaching Hifz and Tajweed.',
    image: '/teachers/sheikh-abdul-rahman.jpg',
    rating: 4.9,
    students: 500
  },
  {
    id: 2,
    name: 'Ustadha Fatima Ahmed',
    title: 'Female Quran Instructor',
    qualification: 'MA Islamic Studies, Hafiza',
    experience: '10 years',
    specialization: ['Quran Reading', 'Tajweed', 'Islamic Studies'],
    language: ['Arabic', 'English'],
    description: 'Ustadha Fatima specializes in teaching female students and children with patience and care.',
    image: '/teachers/ustadha-fatima.jpg',
    rating: 4.8,
    students: 350
  },
  {
    id: 3,
    name: 'Sheikh Muhammad Ali',
    title: 'Tajweed Expert',
    qualification: 'Ijazah in Tajweed and Qira\'at',
    experience: '12 years',
    specialization: ['Tajweed', 'Quran Recitation', 'Ten Qira\'at'],
    language: ['Arabic', 'English', 'French'],
    description: 'Expert in teaching proper pronunciation and Tajweed rules with modern teaching methods.',
    image: '/teachers/sheikh-muhammad.jpg',
    rating: 4.9,
    students: 450
  },
  {
    id: 4,
    name: 'Ustadh Ahmed Hassan',
    title: 'Arabic Language Teacher',
    qualification: 'PhD in Arabic Literature',
    experience: '8 years',
    specialization: ['Arabic Language', 'Quran Translation', 'Tafseer'],
    language: ['Arabic', 'English', 'Urdu'],
    description: 'Specialized in teaching Arabic language and helping students understand Quranic Arabic.',
    image: '/teachers/ustadh-ahmed.jpg',
    rating: 4.7,
    students: 300
  },
  {
    id: 5,
    name: 'Ustadha Aisha Ibrahim',
    title: 'Islamic Studies Teacher',
    qualification: 'MA in Islamic Studies',
    experience: '9 years',
    specialization: ['Islamic Studies', 'Fiqh', 'Hadith'],
    language: ['Arabic', 'English'],
    description: 'Experienced in teaching comprehensive Islamic education to students of all ages.',
    image: '/teachers/ustadha-aisha.jpg',
    rating: 4.8,
    students: 280
  },
  {
    id: 6,
    name: 'Sheikh Omar Abdullah',
    title: 'Noorani Qaida Specialist',
    qualification: 'Certified Quran Teacher',
    experience: '7 years',
    specialization: ['Noorani Qaida', 'Beginner Quran Reading', 'Children Education'],
    language: ['Arabic', 'English', 'Urdu'],
    description: 'Patient and friendly teacher specializing in teaching basics to beginners and children.',
    image: '/teachers/sheikh-omar.jpg',
    rating: 4.9,
    students: 400
  }
];

export const getTeacherById = (id) => {
  return teachersData.find(teacher => teacher.id === id);
};

export const getTeachersBySpecialization = (specialization) => {
  return teachersData.filter(teacher => 
    teacher.specialization.includes(specialization)
  );
};
